document.addEventListener("DOMContentLoaded", function () {
  function updateFreeShippingProgress() {
    const progressBar = document.querySelector(".free-shipping-progress .progress");
    const progressText = document.querySelector(".free-shipping-progress .progress-text");
    const freeShippingText = document.querySelector(".free-shipping-progress .free-shipping-message");

    if (!progressBar || !progressText || !freeShippingText) return;

    // Free shipping threshold in cents
    const freeShippingThreshold = 5000; // $50.00

    // Fetch current cart
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const cartTotal = cart.total_price; // In cents
        let progress = Math.min((cartTotal / freeShippingThreshold) * 100, 100);

        // Update progress bar width
        progressBar.style.width = progress + "%";

        if (cartTotal >= freeShippingThreshold) {
          freeShippingText.textContent = "🎉 Congratulations! You’ve unlocked FREE SHIPPING!";
          progressText.textContent = "100% complete";
        } else {
          const remaining = (freeShippingThreshold - cartTotal) / 100;
          freeShippingText.textContent = `You're only $${remaining.toFixed(2)} away from FREE SHIPPING!`;
          progressText.textContent = `${Math.floor(progress)}% complete`;
        }
      })
      .catch((error) => console.error("Error fetching cart:", error));
  }

  // Run once when the page loads
  updateFreeShippingProgress();

  // Also update when cart changes (Shopify AJAX cart events)
  document.addEventListener("cart:updated", updateFreeShippingProgress);
});
